import { StyleSheet, View, Pressable, Text } from 'react-native';

export default function SmallButton({ label, theme, onPress, isDisabled = false }) {
  if (theme === "basic") {
    return (
      <View
        style={[styles.buttonContainer, { borderWidth: 2, borderColor: isDisabled ? "#ccc" : "#E0CD67", borderRadius: 12 }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: isDisabled ? "#f5f5f5" : "#fff" }]}
          onPress={onPress}
          disabled={isDisabled}
        >
          <Text style={[styles.buttonLabel, { color: isDisabled ? "#999" : "#25292e" }]}>{label}</Text>
        </Pressable>
      </View>
    );
  }

  if (theme === "secondary") {
    return (
      <View
        style={[styles.buttonContainer, { borderWidth: 2, borderColor: isDisabled ? "#ccc" : "#999", borderRadius: 12 }]}
      >
        <Pressable
          style={[styles.button, { backgroundColor: isDisabled ? "#f5f5f5" : "#fff" }]}
          onPress={onPress}
          disabled={isDisabled}
        >
          <Text style={[styles.buttonLabel, { color: isDisabled ? "#999" : "#25292e" }]}>{label}</Text>
        </Pressable>
      </View>
    );
  }

  // Default fallback
  return (
    <View style={styles.buttonContainer}>
      <Pressable 
        style={[styles.button, { backgroundColor: "#fff" }]} 
        onPress={onPress}
        disabled={isDisabled}
      >
        <Text style={[styles.buttonLabel, { color: isDisabled ? "#999" : "#25292e" }]}>{label}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  buttonContainer: {
    height: 36,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    paddingHorizontal: 8,
  },
  button: {
    borderRadius: 8,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 12,
    minWidth: 60,
  },
  buttonLabel: {
    color: '#25292e',
    fontSize: 14,
    fontWeight: '500',
  },
});